import React from "react";
import "./Productsection.css";
import { Link } from "react-router-dom";

function Productsection() {
  return (
    <div className="product-section" id="product-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 ">
            <Link className="product-link" to="/women">
              <img
                src="/img/a62.JPEG
              "
                alt=""
              />
              <h4> WOMEN</h4>
            </Link>
          </div>
          <div className="col-lg-4  ">
            <Link className="product-link" to="/men">
              <img src="/img/a61.JPG" alt="" />
              <h4>MEN</h4>
            </Link>
          </div>
          <div className="col-lg-4  ">
            <Link className="product-link" to="/care-products">
              <img src="/img/a60.JPEG" alt="" />
              <h4>FACE & BODY</h4>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Productsection;
